var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"files-list"},_vm._l((_vm.files),function(file){return _c('li',{key:file.key},[_c('FileLink',{attrs:{"file":file}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }